import {connect} from 'react-redux'
import PromoForm from './PromoForm'
import styles from './DetailPromo.css'

class DetailPromo extends React.Component {
  render () {
    return (
      <div className={styles['detail-wrapper']}>
        <PromoForm />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {}
}

export default connect(mapStateToProps)(DetailPromo)



// WEBPACK FOOTER //
// ./app/pages/Library/Promo/DetailPromo/DetailPromo.js